import service from '@/utils/server';
const modName='/reshipCorn/plan/';

//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'planPageInfo',
    method: 'post',
    data
  });
};

//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'editDetails',
    method: 'post',
    data
  });
};

//编辑提交
export const editData = data => {
  return service({
    url: modName + 'edit',
    method: 'post',
    data
  });
};
//新增提交
export const addData = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};

//毒素主数据
export const toxinDetail = data => {
  return service({
    url: modName + 'toxinDetail',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'planExport',
    method: 'post',
    responseType: 'blob',
    data
  });
};

//禁用计划单
export const closePlan = data => {
  return service({
    url: modName + 'close',
    method: 'post',
    responseType: 'blob',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/bd/corn/reshipCornPlan/api/index.js